import { BlueprintApiItem } from '../../../../api/core'

/**
 * The PC/console game-level blueprints of a family. The `/blueprints` rows carry no
 * game type, so they are told apart by diffing the mixed list
 * (`includePcConsole=true`) against the mobile-only one: whatever only the mixed list
 * names is PC/console. Undefined until both lists are in, so a half-loaded pair is
 * never passed off as "every row is PC/console".
 */
export function pcConsoleOnlyBlueprints(
  mobileBlueprints: BlueprintApiItem[] | undefined,
  mixedBlueprints: BlueprintApiItem[] | undefined
): BlueprintApiItem[] | undefined {
  if (!mobileBlueprints || !mixedBlueprints) return undefined
  const mobileIds = new Set(mobileBlueprints.map((item) => item.id))
  return mixedBlueprints.filter((item) => !mobileIds.has(item.id))
}
